import { Branding, DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";

/**
 * @function EntitlementsAccountsProfilesTableRow
 * @param {STRING} className - Allows us to set a custom className. 
 * @returns {React.Component}
  * @description The is the table row used for the Entitlements Accounts and Entitlements Profile table.
 */
export default function EntitlementsAccountsProfilesTableRow(props) {
    const className = props.className ?? "";

    return (
        <TableItemContainer className={`entitlements-accounts-profiles-table-row ${className}`}>
            {props.children}
        </TableItemContainer>
    )
}

/**
 * @function EntitlementsAccountsTableRow 
 * @param {STRING} accountName - Allows us to set the text data column in the table row.   
 * @param {STRING} className - Allows us to set a custom className. Use "main-col and skewed-col" classses to applied table row styles."
 * @returns {React.Component}
 * @description The is the table row used for the Entitlements Accounts table.
 */
export function EntitlementsAccountsTableRow(props) {
    const name = props.name ?? "[name]";
    const account = props.account ?? {};
    const dataPointCheckbox = props.dataPoint ? { "dataPoint": `${ props.dataPoint }_All_Entitlements_${ account.id }_` } : {};

    return (
        <EntitlementsAccountsProfilesTableRow className="entitlements-accounts-table-row">
            <TableItemTextView className="main-col account-col" text={name} />
            <TableItemView className="all-entitlements-col chevron-col">
            <DisabledPrompt>
                <UICheckbox label="" value="" { ...dataPointCheckbox } />
            </DisabledPrompt>
            </TableItemView>
            <Branding id="stop_payments_abi22" value="true">
                <TableItemTextView className="stop-payments-col" />
            </Branding>
            <TableItemTextView className="views-col" />
            <Branding id="ach_abi22" value="true">
                <TableItemTextView className="ach-from-col" />
                <TableItemTextView className="ach-to-col" />
            </Branding>
            <TableItemTextView className="transfer-from-col" />
            <TableItemTextView className="transfer-to-col" />
            <Branding id="wires_abi22" value="true">
                <TableItemTextView className="wires-col" />
            </Branding>
        </EntitlementsAccountsProfilesTableRow>
    )
}

/**
 * @function EntitlementsProfileTableRow 
 * @param {STRING} profileName - Allows us to set the text data column in the table row.   
 * @param {STRING} className - Allows us to set a custom className. Use "main-col and skewed-col" classses to applied table row styles."
 * @returns {React.Component}
 * @description The is the table row used for the Entitlements Accounts table.
 */
export function EntitlementsProfileTableRow(props) {
    const name = props.name ?? "[name]";
    const profile = props.profile ?? {};
    const dataPointCheckbox = props.dataPoint ? { "dataPoint": `${ props.dataPoint }_All_Entitlements_${ profile.id }_` } : {};

    return (
        <EntitlementsAccountsProfilesTableRow className="entitlements-profile-table-row">
            <TableItemTextView className="main-col profile-col" text={name} />
            <TableItemView className="all-entitlements-col chevron-col">
            <DisabledPrompt>
                <UICheckbox label="" value="" { ...dataPointCheckbox } />
            </DisabledPrompt>
            </TableItemView>
            <Branding id="rxp17_abi22" value="true">
                <TableItemTextView className="bill-pay-access-col" />
            </Branding>
            <TableItemView className="update-profile-col chevron-col">
            <DisabledPrompt>
                <UICheckbox label="" value="" />
            </DisabledPrompt>
            </TableItemView>
            <Branding id="zle_abi22" value="true">
                <TableItemTextView className="zelle-access-col"  />
            </Branding>
            <Branding id="tax_documents_abi22" value="true">
                <TableItemTextView className="tax-documents-col"  />
            </Branding>
        </EntitlementsAccountsProfilesTableRow>
    )
}
